import { VisualsDashboardWidgetSizingEnum } from 'dashboard/enums/visuals/visuals-dashboard-widget-sizing.enum';
import { VisualsDashboardWidgetEnum } from 'dashboard/enums/visuals/visuals-dashboard-widgets.enum';
import { IceListWidgetResponse } from 'dashboard/interfaces/visuals/ice-list-widget-response.interface';

export interface DashboardListWidget {
    widgetId: number;
    key: VisualsDashboardWidgetEnum;
    sizes: VisualDashboardWidgetSize[];
    widgetTypeId: number;
    isSelected?: boolean;
    isAddedToDashboard?: boolean;
    iceListWidget: IceListWidgetResponse;
    searchableText: string;
    translatedFullDescription: string;
    defaultSettings: HistoryWidgetSettings | ImageTrackerDistributionSettings | null;
    selectedSetting?: HistoryWidgetSettings | ImageTrackerDistributionSettings | null;
}

export interface VisualDashboardWidgetSize {
    size: VisualsDashboardWidgetSizingEnum;
    isDefault: boolean;
}

export interface HistoryWidgetSettings {
    optionValue: number;
    name: string;
}

export interface ImageTrackerDistributionSettings {
    isListings: boolean;
    isPhotos: boolean;
    distributorIds: number[];
}

export function isHistoryWidgetSettings(settings: unknown): settings is HistoryWidgetSettings {
    return settings !== null && typeof settings === 'object' && 'optionValue' in settings && 'name' in settings;
}

export function isImageTrackerDistributionSettings(settings: unknown): settings is ImageTrackerDistributionSettings {
    return (
        settings !== null &&
        typeof settings === 'object' &&
        'isListings' in settings &&
        'isPhotos' in settings &&
        'distributorIds' in settings
    );
}
